module.exports = __webpack_public_path__ + "media/10.c988febf.mp4";